module.exports = __webpack_public_path__ + "static/media/phosagro.d2d31447.png";